import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import loyaltyIcon from '~Assets/icons/loyalty.svg';
import { useExpressCart } from '../../../Providers/ExpressCartProvider';

/** Same box as a cart line, so it reads as part of the list. */
const Banner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 10px;
  border-radius: 16px;
  background: var(--colorBlueGray100);
  color: var(--eposText);
`;

const Text = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.span`
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
`;

const Body = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--eposMutedText);
`;

/**
 * One row at the top of the cart once a member was identified: who they are.
 * Renders nothing until then, so cart taps never pay for it.
 */
const LoyaltyBanner: FC = () => {
  const { i18n } = useI18n();
  const expressCart = useExpressCart();
  const loyalty = expressCart.loyalty;

  if (!loyalty?.memberId) {
    return null;
  }

  return (
    <Banner data-testid="epos-loyalty-member">
      <Icon src={loyaltyIcon} color="var(--eposText)" width="24px" height="24px" />
      <Text>
        <Title>{i18n('Express.Loyalty.MemberConnected')}</Title>
        <Body>{loyalty.memberName}</Body>
      </Text>
    </Banner>
  );
};

export default memo(LoyaltyBanner);
